"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contexts = require("../../../contexts");
var _core = require("../../../core/services/core");
var _preparePayload = require("./preparePayload");
var _actions = require("../../../contexts/actions");
var _constants = require("../../../constants/constants");
var _commonUtils = require("../../../utils/commonUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * loads the given script by dynamically adding to the dom
 *
 * @param {scriptlink} src
 * @returns
 */
var loadScript = function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () {
      resolve();
    });
    script.addEventListener('error', function (e) {
      reject(e);
    });
    document.body.appendChild(script);
  });
};
var GooglePayBtn = function GooglePayBtn(props) {
  var _useContext = (0, _react.useContext)(_contexts.GooglePayContext),
    googlePayConfiguration = _useContext.state;
  var _useContext2 = (0, _react.useContext)(_contexts.PaymentContext),
    paymentDispatch = _useContext2.dispatch,
    _useContext2$state = _useContext2.state,
    cartAmount = _useContext2$state.cartAmount,
    activePaymentMethods = _useContext2$state.activePaymentMethods,
    rmsId = _useContext2$state.rmsId;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    scriptLoaded = _useState2[0],
    setScriptLoaded = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    googlePayClient = _useState4[0],
    setGooglePayClient = _useState4[1];
  var _useState5 = (0, _react.useState)(3),
    _useState6 = _slicedToArray(_useState5, 2),
    attempts = _useState6[0],
    setAttempts = _useState6[1];
  var stateRef = (0, _react.useRef)({});
  stateRef.current = {
    cartAmount: cartAmount
  };
  var inputCustomData = props.inputCustomData,
    customAuthCallBack = props.customAuthCallBack,
    customFunctions = props.customFunctions,
    setProcessing = props.setProcessing;
  var _inputCustomData$cart = inputCustomData.cart,
    currencyCode = _inputCustomData$cart.currencyCode,
    countryCode = _inputCustomData$cart.countryCode,
    languageCode = _inputCustomData$cart.languageCode,
    checkoutId = inputCustomData.checkoutId;
  var environment = inputCustomData.environment === 'live' ? 'PRODUCTION' : 'TEST';

  //construct the supportedCardTypes array according to the GooglePay request
  var supportedCardTypes = googlePayConfiguration.supportedCardNetworks.map(function (cardType) {
    switch (cardType) {
      case 'AX':
        return 'AMEX';
      case 'VI':
        return 'VISA';
      case 'MC':
        return 'MASTERCARD';
      case 'DI':
        return 'DISCOVER';
    }
  });

  // Auth call handler to handle when user clicks on the place order button
  var authCallHandler = function authCallHandler() {
    onGooglePaymentButtonClicked();
  };

  // load the google pay js and update the state
  var loadGooglePayJS = function loadGooglePayJS() {
    var googlePayScript = loadScript(_constants.GOOGLE_PAY_SCRIPT_URL);
    googlePayScript.then(function () {
      // validate google pay loaded properly, otherwise try again
      var scriptValid = validateGooglePayScript();
      if (scriptValid) {
        setScriptLoaded(true);
      } else {
        setAttempts(attempts - 1);
      }
    }).catch( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(error) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return customFunctions['onError']({
                paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY,
                error: error
              });
            case 2:
              setScriptLoaded(false);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
  (0, _react.useEffect)(function () {
    if (attempts > 0 && !scriptLoaded) {
      loadGooglePayJS();
    } else if (!scriptLoaded) {
      paymentDispatch((0, _actions.updateActivePaymentMethods)((0, _commonUtils.disablePaymentMethod)(activePaymentMethods, _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY)));
      customFunctions['onError']({
        paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY
      });
    }
  }, [attempts, scriptLoaded]);

  /**
   * When ever google pay client has changed, check whether the GooglePay is ready to pay.
   * When it is ready to pay, add the google pay button to the container and prefetch payment data.
   */
  (0, _react.useEffect)(function () {
    if (googlePayClient) {
      googlePayClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
        if (response.result) {
          addGooglePayButton();
          prefetchGooglePaymentData();
        } else {
          paymentDispatch((0, _actions.updateActivePaymentMethods)((0, _commonUtils.disablePaymentMethod)(activePaymentMethods, _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY)));
        }
      }).catch( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(error) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                paymentDispatch((0, _actions.updateActivePaymentMethods)((0, _commonUtils.disablePaymentMethod)(activePaymentMethods, _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY)));
                _context2.next = 3;
                return customFunctions['onError']({
                  paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY,
                  error: error
                });
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    paymentDispatch((0, _actions.registerAuthCallHandler)({
      paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY,
      authCallHandler: authCallHandler
    }));
  }, [googlePayClient, cartAmount]);

  // when script is loaded and google pay client is null for the first time, get the payments client and update the state
  if (scriptLoaded && !googlePayClient) {
    var paymentsClient = new window.google.payments.api.PaymentsClient({
      environment: environment
    });
    setGooglePayClient(paymentsClient);
  }
  var validateGooglePayScript = function validateGooglePayScript() {
    var _window$google;
    return ((_window$google = window.google) === null || _window$google === void 0 || (_window$google = _window$google.payments) === null || _window$google === void 0 || (_window$google = _window$google.api) === null || _window$google === void 0 ? void 0 : _window$google.PaymentsClient) != undefined;
  };

  // base request to define the api version of Google Pay.
  var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
  };
  var allowedCardNetworks = supportedCardTypes;

  // supported authentication methods: consits of either of them or both [PAN_ONLY, CRYPTOGRAM_3DS]
  var allowedCardAuthMethods = googlePayConfiguration.authenticationMethods;

  // we are using direct integration so tokenization type will be direct
  var tokenizationSpecification = {
    type: 'DIRECT',
    parameters: {
      protocolVersion: 'ECv2',
      publicKey: googlePayConfiguration.merchantPublicKey
    }
  };

  /**
   * Base card payment method which consits of allowed card networks, authentication methods.
   * Accept full billing address which will be passed to the gateway
   */
  var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: allowedCardAuthMethods,
      allowedCardNetworks: allowedCardNetworks,
      billingAddressRequired: true,
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true
      }
    }
  };
  var cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
    tokenizationSpecification: tokenizationSpecification
  });

  /**
   * Get the google pay isReadyToPay request payload
   *
   * @returns payload that will be send to google pay api to determine readiness of the payment.
   */
  var getGoogleIsReadyToPayRequest = function getGoogleIsReadyToPayRequest() {
    return Object.assign({}, baseRequest, {
      allowedPaymentMethods: [baseCardPaymentMethod]
    });
  };

  /**
   * Payment data request that will be passed to Google Pay api to open the payment sheet to the user
   * @returns {object} PaymentDataRequest fields
   */
  var getGooglePaymentDataRequest = function getGooglePaymentDataRequest() {
    var paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.emailRequired = true;
    var merchantOrigin, authJwt;
    if (googlePayConfiguration.authJwt && googlePayConfiguration.merchantOrigin) {
      authJwt = googlePayConfiguration.authJwt;
      merchantOrigin = googlePayConfiguration.merchantOrigin;
    }
    paymentDataRequest.merchantInfo = {
      merchantId: googlePayConfiguration.merchantId,
      merchantName: googlePayConfiguration.displayName,
      authJwt: authJwt,
      merchantOrigin: merchantOrigin
    };
    return paymentDataRequest;
  };

  // Add Google Pay button to the google pay container
  var addGooglePayButton = function addGooglePayButton() {
    var button = googlePayClient.createButton({
      onClick: onGooglePaymentButtonClicked,
      allowedPaymentMethods: [baseCardPaymentMethod],
      buttonLocale: languageCode ? languageCode.split('-')[0] : 'en'
    });
    document.getElementById('googlePayContainer').appendChild(button);
  };

  // transaction info to be passed to the GooglePay
  var getGoogleTransactionInfo = function getGoogleTransactionInfo() {
    return {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: stateRef.current.cartAmount + '',
      currencyCode: currencyCode,
      countryCode: countryCode,
      checkoutOption: 'COMPLETE_IMMEDIATE_PURCHASE'
    };
  };

  /**
   * Prefetch GooglePay payment data after adding GooglePay button to the container.
   * This option allows faster loading of payment sheet to the user.
   */
  var prefetchGooglePaymentData = function prefetchGooglePaymentData() {
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

    /* 
    dynamically add cvcRequired field to the paymentDataRequest because by default google 
    pay will throw error if we set cvcRequired field in the paymentDataRequest. 
    Google Pay API can be enabled to collect CVV and We should contact Google Pay team to support this field.
    */
    if (googlePayConfiguration.enableCVC) {
      paymentDataRequest['allowedPaymentMethods'][0]['parameters']['cvcRequired'] = true;
    }
    googlePayClient.prefetchPaymentData(paymentDataRequest);
  };

  /**
   * Handler to be called when user clicks on the GooglePay button.
   * This handler will also work as a callback for place order button.
   * That means when user clicks on the place order button in the widget, this method gets
   * executed to open the payment sheet.
   */
  var onGooglePaymentButtonClicked = function onGooglePaymentButtonClicked() {
    if (customFunctions['customValidate'] ? !customFunctions['customValidate']() : false) {
      return;
    }
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();

    /* 
    dynamically add cvcRequired field to the paymentDataRequest because by default google 
    pay will throw error if we set cvcRequired field in the paymentDataRequest. 
    Google Pay API can be enabled to collect CVV and We should contact Google Pay team to support this field.
    */
    if (googlePayConfiguration.enableCVC) {
      paymentDataRequest['allowedPaymentMethods'][0]['parameters']['cvcRequired'] = true;
    }
    googlePayClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
      var serverPayload = (0, _preparePayload.prepareServerPayload)({
        payloadFromGoogle: paymentData,
        cartAmount: stateRef.current.cartAmount,
        currencyCode: currencyCode,
        rmsId: rmsId
      });
      var postValidateResponse = (0, _preparePayload.constructPostValidateResponse)(customFunctions, serverPayload.billingAddress, _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY, serverPayload.user);
      Promise.resolve(postValidateResponse).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(result) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(result || result == undefined)) {
                  _context3.next = 5;
                  break;
                }
                setProcessing(true);
                _context3.next = 4;
                return (0, _core.initiatePayment)(checkoutId, serverPayload, customAuthCallBack, paymentDispatch);
              case 4:
                setProcessing(false);
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }()).catch( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(error) {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return customFunctions['onError']({
                  paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY,
                  error: error
                });
              case 2:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    }).catch( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(error) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(error.statusCode == 'CANCELED')) {
                _context5.next = 5;
                break;
              }
              _context5.next = 3;
              return customFunctions['onCancel']({
                paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY
              });
            case 3:
              _context5.next = 7;
              break;
            case 5:
              _context5.next = 7;
              return customFunctions['onError']({
                paymentMethod: _constants.PAYMENT_METHOD_ALIAS.GOOGLE_PAY,
                error: error
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }());
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "googlePayContainer",
    style: {
      display: 'none'
    }
  });
};
GooglePayBtn.propTypes = {
  inputCustomData: _propTypes.default.object.isRequired,
  customAuthCallBack: _propTypes.default.func.isRequired,
  customFunctions: _propTypes.default.object,
  setProcessing: _propTypes.default.func
};
var _default = GooglePayBtn;
exports.default = _default;